"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const qs_1 = __importDefault(require("qs"));
const lodash_1 = __importDefault(require("lodash"));
const planPrefix = '/api/console/billing/plan';
const API = {
    getBillingPlan: `${planPrefix}/get`,
    listBillingPlan: `${planPrefix}/list`,
    checkPlanSlugExisted: `${planPrefix}/check`,
    createPlan: `${planPrefix}/create`,
    updatePlanDisplay: `${planPrefix}/configuration/display`,
    updatePlanVerification: `${planPrefix}/configuration/verification`,
    updatePlanKycBot: `${planPrefix}/configuration/kycBot`,
};
class Plan {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getPlanDetail(planId, clientId) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.getBillingPlan, {
            params: {
                plan_id: planId,
                clientId,
            },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getPublishedPlan(clientId) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.get(API.getBillingPlan, {
            params: {
                clientId,
            },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async getAllPlan(planName, page = 0, limit = 10) {
        const query = {
            page,
            limit,
            name: planName,
        };
        const url = `${API.listBillingPlan}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url);
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: 0,
            },
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.paging = resBody.paging;
        data.entities = resBody.entities;
        return data;
    }
    async checkPlanSlugExisted(planSlug) {
        const data = {
            result: null,
            entities: {},
        };
        const url = `${API.checkPlanSlugExisted}?${qs_1.default.stringify({
            slug: planSlug,
        })}`;
        const res = await this._httpClient.get(url);
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async createPlan(name, slug) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.post(API.createPlan, {
            name,
            slug,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async updatePlanDisplay(planId, updateParams) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updatePlanDisplay, {
            planId,
            ...updateParams,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async updatePlanVerification(planId, verifications) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updatePlanVerification, {
            planId,
            verifications,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    async updatePlanKycBot(planId, kycBot) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updatePlanKycBot, {
            planId,
            kycBot,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = Plan;
